import React, { FC } from 'react'
import arrowRight from '../../images/arrow-right.svg'

interface Props {
  onClick?: () => void
  className?: string
  compact?: boolean
}

const NavigationArrow: FC<Props> = ({ onClick, className = '', compact, children }) => (
  <div
    className={`navigation-arrow__wrapper ${compact && 'navigation-arrow__wrapper--compact'} ${className}`}
    onClick={onClick}
  >
    <img src={arrowRight} alt="Navigate back" className="navigation-arrow__icon" />
    {children && <span className="ml-2 cursor-pointer">{children}</span>}
  </div>
)

export default NavigationArrow
